import { BrowserView } from 'components/DeviceDetect'
import SelectInput from 'components/Input/SelectInput'
import React, { useEffect, useState } from 'react'
import useInnerPage from 'store/InnerPageProvider'
import { SectionProductSort } from 'style/Global.style'

const orderingOptions = {
  '': {
    label: 'დალაგება',
    value: '',
  },
  sale: {
    label: 'ფასდაკლება',
    value: 'sale',
  },
  price_asc: {
    label: 'ფასი ზრდადობით',
    value: 'price_asc',
  },
  price_desc: {
    label: 'ფასი კლებადობით',
    value: 'price_desc',
  },
  date_asc: {
    label: 'თარიღი ზრდადობით',
    value: 'date_asc',
  },
  date_desc: {
    label: 'თარიღი კლებადობით',
    value: 'date_desc',
  },
}

const perPageOptions = {
  20: {
    label: '20 პროდუქტი',
    value: '20',
  },
  40: {
    label: '40 პროდუქტი',
    value: '40',
  },
  80: {
    label: '80 პროდუქტი',
    value: '80',
  },
  100: {
    label: '100 პროდუქტი',
    value: '100',
  },
}

export const Ordering = () => {
  const { setParam, params } = useInnerPage()
  const [ordering, setOrdering] = useState({})

  useEffect(() => {
    setOrdering(
      orderingOptions[params.ordering] ? orderingOptions[params.ordering] : {}
    )
  }, [params.perPage, params.ordering])

  const onOrderingChange = val => {
    setOrdering(val)
    setParam('ordering', val.value)
  }

  return (
    <SelectInput
      onChange={onOrderingChange}
      placeholder="დალაგება"
      value={ordering}
      options={Object.values(orderingOptions)}
    />
  )
}

export default function OrderingAndfilters(props) {
  const { setParam, params } = useInnerPage()
  const [perPage, setPerPage] = useState({})

  useEffect(() => {
    setPerPage(
      perPageOptions[params.perPage] ? perPageOptions[params.perPage] : {}
    )
  }, [params.perPage, params.ordering])

  const onPageChange = val => {
    setPerPage(val)
    setParam('perPage', val.value)
  }

  return (
    <SectionProductSort>
      <BrowserView>
        <p>სულ {props.total || 0} პროდუქტი</p>
      </BrowserView>
      <div className="flex flex-col w-full md:flex-row justify-center items-center gap-x-4">
        <BrowserView>
          <SelectInput
            onChange={onPageChange}
            value={perPage}
            options={Object.values(perPageOptions)}
          />
        </BrowserView>
        <Ordering />
      </div>
    </SectionProductSort>
  )
}
